/* tslint:disable */
/* eslint-disable */
export enum UserSortColumn {
  UserName = 'USER_NAME',
  TenantName = 'TENANT_NAME'
}
